import type { FunctionComponent } from 'react'
import { forwardRef } from 'react'
import { PatternFormat as NumberFormat } from 'react-number-format'

import type { TextInputProps } from '@components/input/text-input'
import { TextInput } from '@components/input/text-input'

const CURRENCY_FORMAT = '$###'

/** Currency input with dollar sign mask prefix  */
export const CurrencyInput: FunctionComponent<
    React.PropsWithChildren<CurrencyInputProps>
> = forwardRef<HTMLInputElement, CurrencyInputProps>(
    (
        {
            size,
            placeholder,
            onFocus,
            onBlur,
            'data-testid': dataTestId,
            format = CURRENCY_FORMAT,
            ...restOfProps
        },
        ref,
    ) => (
        <NumberFormat
            {...restOfProps}
            size={size}
            type='text'
            getInputRef={ref}
            format={format}
            customInput={TextInput}
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            data-testid={dataTestId}
        />
    ),
)

export type CurrencyInputProps = Omit<TextInputProps, 'type'> & {
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    format?: string
}
